module.exports = __webpack_public_path__ + "img/4-preview.c136db0e.jpg";